export class DropDownElement {
    id: number;
    name: string;
    value: string;

    constructor(id: number, name: string, value: string) {
        this.id = id;
        this.name = name;
        this.value = value;
    }
}

export class DropDownFormatter {
    elements: DropDownElement[];
    trigger: () => void;

    constructor(elements: DropDownElement[] = [], trigger: () => void = () => { console.log("default"); }) {
        this.elements = elements;
        this.trigger = trigger;
    }
}
